import "./style.scss"

import 'master';
import 'slick-carousel';

$(function() {
    // $(".galleryWrapper").slick({        
    //     slidesToShow: 1,
    //     arrows: false,
    //     dots: true,
    //     infinite: true
    //   });

});
